module.exports = "/_next/static/images/vi-2cca2f616f975184bd1c7c32a27d3318.svg";